export default __webpack_public_path__ + "static/media/wallet-16px.6af5b788.svg";